import React from 'react';
import {
  Divider,
  FormControl,
  TextField as MUITextField,
  Button,
  Box,
  Typography
} from '@mui/material';
import api from "../../services/api";
import {
  TextField,
} from '../../components';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { pt } from 'yup-locale-pt';
import { useStoreState, useStoreActions } from 'easy-peasy';
import PersonIcon from '@mui/icons-material/Person';
yup.setLocale(pt);

const MeusDados = () => {
  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);
  let setUser = useStoreActions((actions) => actions.auth.setUser);
  let user = useStoreState((state) => state.auth.user);
  const schema = yup.object({
    name: yup.string().label('Nome').required(),
  }).required();

  const useFormRef = useForm({
    mode: 'onTouched',
    resolver: yupResolver(schema),
    defaultValues: {
      name: user?.name
    }
  });

  const { handleSubmit, reset,
          formState: {isDirty, isSubmitting} } = useFormRef;

  const submit = async (data) => {
    startLoading();
    try {
      setUser((await api.http.put('auth-user',data)).data);
      stopLoading({ severity: 'success' });
      reset({ keepValues: true});
    } catch(error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    };

  };

  return (
    <div>
      <Divider>
        <Typography variant="h4" sx={{ display: 'flex', alignItems: 'center' }}>
          <PersonIcon sx={{'mr':1}} /> Meus dados
        </Typography>
      </Divider>
      <form onSubmit={handleSubmit(submit)} >
        <FormControl sx={{ my: 2 }} fullWidth>
          <TextField field="name"
                     schema={schema} useFormRef={useFormRef} />
        </FormControl>
        <FormControl sx={{ my: 2 }} fullWidth>
          <MUITextField type="email" label="Email" defaultValue={user?.email}
                        disabled={true}/>
        </FormControl>
        <Box sx={{ mt: 2 }}>
          <Button type="submit" variant="contained" size="large"
                  disabled={!isDirty || isSubmitting}>ALTERAR</Button>
        </Box>
      </form>
      </div>
  );
};
export default MeusDados;
